import React from "react";
import { getProductImageFallback } from "../../data/storefront";

const formatPrice = (value) => `${Number(value || 0).toFixed(2)} EUR`;

const ProductSearch = ({ results, onSelectProduct, query, onEditProduct }) => {
  return (
    <div className="h-100 d-flex flex-column">
      <div className="p-3 pos-results-head">
        <span>{results.length} produits trouves pour "{query}"</span>
      </div>
      <div className="flex-grow-1 overflow-auto p-2">
        <ul className="list-unstyled d-flex flex-column gap-2 mb-0">
          {results.map(product => (
            <li
              key={product.id}
              className="pos-result-item"
              onClick={() => onSelectProduct(product)}
            >
              <img
                src={product.imageUrl || getProductImageFallback(product)}
                alt={product.name}
                style={{ width: "50px", height: "50px", objectFit: "cover", borderRadius: "4px" }}
              />
              <div className="flex-grow-1 overflow-hidden">
                <div className="pos-result-name text-truncate">{product.name}</div>
                <div className="pos-result-meta text-truncate">
                  {product.sku && <span className="me-2">Réf. {product.sku}</span>}
                  <span className={product.stock !== undefined && product.stock !== null && Number(product.stock) <= 0 ? "text-danger fw-bold" : "text-success fw-bold"}>
                    Stock : {product.stock !== undefined && product.stock !== null ? Number(product.stock) : "-"}
                    {product.stock !== undefined && product.stock !== null && Number(product.stock) <= 0 && " (Rupture)"}
                  </span>
                </div>
              </div>
              <div className="text-end ms-2 d-flex align-items-center gap-2">
                <div className="d-flex flex-column align-items-end">
                   <div className="pos-result-price">{formatPrice(product.price)}</div>
                   {product.purchasePrice !== undefined && (
                     <div className="text-muted" style={{fontSize: "0.75rem"}}>PA: {formatPrice(product.purchasePrice)}</div>
                   )}
                </div>
                <button 
                   className="btn btn-sm btn-info text-white ms-2" 
                   onClick={(e) => { e.stopPropagation(); if (onEditProduct) onEditProduct(product); }}
                >
                   <i className="bi bi-pencil-square"></i>
                </button>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default ProductSearch;
